import { AspectRatio, Box, Section, Text } from "@vinomofo/components";

import { Award, StorefrontImage, TastingNote } from "../../types";
import { BlockWithHeading } from "../block-with-heading";
import { IconBadge } from "./IconBadge";
import { AwardsBlock } from ".";
import { GatsbyImage } from "gatsby-plugin-image";

export interface WineNotesSingleProps {
  awards: Array<Award>;
  tastingNotes: Array<TastingNote>;
  bottleImage: StorefrontImage | null;
  name: string | undefined;
}

export const WineNotesSingle = ({
  awards,
  tastingNotes,
  bottleImage,
  name,
}: WineNotesSingleProps): JSX.Element => {
  const badgeWidth = "80px";

  return (
    <Section
      py={
        bottleImage
          ? ["40px"]
          : ["50px", "50px", awards?.length > 3 ? "125px" : "185px"]
      }
    >
      <Box
        display={["block", "block", "flex"]}
        justifyContent="space-between"
        maxWidth={bottleImage ? ["100%"] : ["100%", "66%", "100%"]}
      >
        {awards?.length !== 0 && (
          <BlockWithHeading heading="Awards">
            <AwardsBlock awards={awards} badgeWidth={badgeWidth} />
          </BlockWithHeading>
        )}
        {bottleImage && (
          <Box flex={1} py={["25px", "10px"]}>
            <AspectRatio ratio={[1, 16 / 9, 0.8]}>
              <GatsbyImage
                image={bottleImage}
                style={{ width: "100%", height: "100%", textAlign: "center" }}
                imgStyle={{ objectFit: "contain", bottom: 0 }}
                alt={name || ""}
              />
            </AspectRatio>
          </Box>
        )}
        <BlockWithHeading heading="Tasting Notes">
          <Box
            display="flex"
            flexWrap="wrap"
            justifyContent={["flex-start", "flex-start", "flex-start"]}
            gridGap={["0 20px", "0 98px", "0 40px"]}
          >
            {tastingNotes.length ? (
              tastingNotes.map((tastingNote, i) => (
                <IconBadge
                  width={badgeWidth}
                  marginBottom={["15px", "35px"]}
                  mx="5px"
                  key={i}
                  {...tastingNote}
                />
              ))
            ) : (
              <Text variant="sm">No tasting notes available</Text>
            )}
            {tastingNotes.length % 3 > 0 && <Box width={badgeWidth} mx="5px" />}
          </Box>
        </BlockWithHeading>
      </Box>
    </Section>
  );
};
